import React from 'react';
import Navbar from './Navbar';
import './Home.css';
import FeaturesSection from './FeaturesSection';
import HeroSection from './HeroSection';
import AboutSection from './AboutUs';
import TestimonialsSection from './TestimonialsSection';
import ContactSection from './Contact';
import Footer from './Footer';

const Home = () => {
  return (
    <div className="home">
      <Navbar />
      {/* Add id attributes to each section for scrolling */}
      <div id="hero">
        <HeroSection />
      </div>
      <div id="features">
        <FeaturesSection />
      </div>
      <div id="about">
        <AboutSection />
      </div>
      {/* <div id="testimonials">
        <TestimonialsSection />
      </div> */}
      <div id="contact">
        <ContactSection />
      </div>
      <div>
        <Footer />
      </div>
    </div>
  );
};

export default Home;
